import { render, staticRenderFns } from "./TinyMCE.vue?vue&type=template&id=896baf1e&scoped=true&"
import script from "./TinyMCE.vue?vue&type=script&lang=js&"
export * from "./TinyMCE.vue?vue&type=script&lang=js&"
import style0 from "./TinyMCE.vue?vue&type=style&index=0&id=896baf1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896baf1e",
  null
  
)

export default component.exports